import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-content-pass-card',
  templateUrl: './content-pass-card.component.html',
  styleUrls: ['./content-pass-card.component.scss'],
})
export class ContentPassCardComponent {
  //#region Inputs declarations
  @Input() imgName?: String;
  @Input() iconName?: string;
  @Input() passTitle?: string;
  @Input() passSubTitle?: string;
  @Input() passAddonIconName?: string;
  @Input() passAddonTitle?: string;
  @Input() passAddonSubTitle?: string;
  @Input() notSelected?: boolean = false;
  //#endregion Inputs declarations

  //#region Outputs declarations
  @Output() public handleClick = new EventEmitter<any>();
  //#endregion Outputs declarations
}
